<template>
  <label class="checkbox is-unselectable is-small-mobile-narrow">
    <input
      type="checkbox"
      :checked="modelValue"
      @change="emit('update:modelValue', $event.target.checked)"
    />
    Archived
    <span class="is-hidden-mobile-narrow">only</span>
  </label>
</template>

<script setup>
  defineProps({
    modelValue: { type: Boolean, required: true },
  });
  const emit = defineEmits(["update:modelValue"]);
</script>

<style scoped lang="scss">
  @import "~jose_modern/css";

  @media screen and (max-width: 320px) {
    .is-hidden-mobile-narrow {
      display: none !important;
    }

    .is-small-mobile-narrow {
      font-size: $size-7 !important;
    }
  }
</style>
